<template>
	<div
		:class="visible ? '' : 'k-sr-only'"
		:aria-atomic="String(atomic)"
		:aria-live="live"
		:role="role"
		v-bind="$attrs"
	>
		{{ message }}
	</div>
</template>

<script>
export default {
	name: 'KLiveRegion',
	props: {
		atomic: {
			type: Boolean,
			default: true
		},
		live: {
			type: String,
			default: 'polite'
		},
		message: {
			type: String,
			default: ''
		},
		role: {
			type: String,
			default: 'status'
		},
		visible: {
			type: Boolean,
			default: false
		}
	}
}
</script>
